import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isNil } from 'ramda'
import Page from '@/components/page'
import { NamedWizard, WizardContent } from '@/components/wizard'
import { getFees } from '@/models/payment/ports'
import { structure } from '@/styles'
import Context from './context'
import Details from './details'
import PaymentMethod from './payment-method'
import PaymentStatus from './payment-status'

const tenantHeaderHeight = 50

const MakePayment = ({ paymentData, history }) => {
  const { t } = useTranslation()
  const [currentStep, setCurrentStep] = useState('info')
  const [formData, setFormData] = useState({})
  const [feesInfo, setFeesInfo] = useState(null)
  const [paymentMethod, setPaymentMethod] = useState(null)
  const hasFeesInfo = !isNil(feesInfo)
  const hasPaymentData = !isNil(paymentData)

  useEffect(() => {
    if (
      paymentData.payment_status === 'collecting_funds' ||
      paymentData.payment_status === 'incomplete'
    ) {
      setCurrentStep('status')
    }
  }, [paymentData])

  useEffect(() => {
    const getFeesInfo = async () => {
      const { body, response } = await getFees({
        body: {
          amount: paymentData.requested_amount
        }
      })

      if (response.ok && body) setFeesInfo(body)
    }
    if (hasPaymentData && !hasFeesInfo) {
      getFeesInfo()
    }
  }, [hasPaymentData, hasFeesInfo, paymentData.requested_amount])

  if (!paymentData) return null

  const WIZARD_STEPS = {
    info: t('r.payment.edit.make_payment_payment_info.text', 'Payment Info'),
    details: t('r.payment.edit.make_payment_review_details.text', 'Review Details')
  }

  const WIZARD_STEPS_CRYPTO = {
    info: t('r.payment.edit.make_payment_payment_info.text', 'Payment Info'),
    status: t('r.payment.edit.make_payment_payment_status.text', 'Payment Status')
  }

  const handleBack = () => {
    if (currentStep === 'details') {
      setCurrentStep('info')
    } else {
      history.goBack()
    }
    window.scrollTo(0, 0)
  }

  return (
    <>
      <NamedWizard
        steps={
          paymentMethod === 'crypto' || currentStep === 'status'
            ? WIZARD_STEPS_CRYPTO
            : WIZARD_STEPS
        }
        currentStep={currentStep}
        stickyTop={structure.header.height + tenantHeaderHeight}
        stickyTopMobile={structure.header.heightMobile}
      />
      <Context.Provider
        value={{
          formData,
          setFormData,
          paymentData,
          feesInfo,
          setFeesInfo,
          setPaymentMethod
        }}
      >
        <WizardContent currentStep={currentStep}>
          <Page index="info">
            <PaymentMethod setCurrentStep={setCurrentStep} handleBack={handleBack} />
          </Page>
          <Page index="details">
            <Details handleBack={handleBack} />
          </Page>
          <Page index="status">
            <PaymentStatus handleBack={handleBack} />
          </Page>
        </WizardContent>
      </Context.Provider>
    </>
  )
}

export default MakePayment
